<template>

  <b-nav-item to="/default_home">
    <i class="fa mr-2 fa-home text-black" font-scale="1"></i>Home
  </b-nav-item>

</template>
<script>
import {CollapseTransition} from "vue2-transitions";

export default {
  name: 'side-home-default-group',
  components: {
    CollapseTransition
  },
  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],

      homeCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },
    }
  },
  mounted() {

  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>